export const AgentsGoChatIcon = () => (
  <svg width="71" height="71" viewBox="0 0 71 71" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M43.8188 49.8165L35.7111 45.5029C35.2705 45.2664 34.7333 45.2664 34.2927 45.5029L26.185 49.8165C24.8799 50.5097 23.4573 49.103 24.2085 47.8636L33.7346 32.1827C34.3011 31.249 35.6985 31.249 36.2651 32.1827L45.7911 47.8636C46.5423 49.103 45.1239 50.5097 43.8146 49.8165H43.8188ZM35.0019 29.0514C37.5828 29.0514 39.6726 27.025 39.6726 24.5257C39.6726 22.0264 37.5828 20 35.0019 20C32.4211 20 30.3312 22.0264 30.3312 24.5257C30.3312 27.025 32.4211 29.0514 35.0019 29.0514Z"
      fill="url(#paint0_linear_1735_14451)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1735_14451"
        x1="35"
        y1="-0.110374"
        x2="35"
        y2="68.4826"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B3E0FF" />
        <stop offset="1" stopColor="#D7D3FE" />
      </linearGradient>
    </defs>
  </svg>
)

export const AgentsProofreaderIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.002 -0.000610352C24.8405 -0.000610352 32.0018 7.16192 32.002 15.9994C32.002 23.7311 26.5191 30.1823 19.2285 31.6752C18.1872 31.8886 17.1084 31.9994 16.0078 31.9994H0.00195312V15.9994C0.00209891 7.16219 7.16375 -0.000176156 16.002 -0.000610352ZM15.252 4.84314C9.69032 5.22641 5.18101 9.8367 4.91016 15.4037C4.60132 21.7952 9.71029 27.0907 16.0332 27.0912C22.3566 27.0912 27.1738 22.0919 27.1738 15.9506C27.1738 15.4515 27.1368 14.9625 27.0742 14.4838H19.877L18.0898 17.4232H24.1113C23.18 22.5383 17.4907 26.0208 11.8066 23.0756C10.584 22.4429 9.58873 21.4642 8.94531 20.2416C5.67549 14.0153 10.1416 7.7515 16.0371 7.75134C18.5096 7.75134 20.7331 8.85311 22.2383 10.5912L23.8164 7.99158C21.6363 5.85915 18.5855 4.60829 15.252 4.84314Z"
      fill="url(#paint0_linear_1462_295)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1462_295"
        x1="16.002"
        y1="-21.4517"
        x2="16.002"
        y2="51.7142"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B3E0FF" />
        <stop offset="1" stopColor="#D7D3FE" />
      </linearGradient>
    </defs>
  </svg>
)

export const AgentsParaphraserIcon = () => (
  <svg
    width="35"
    height="34"
    viewBox="0 0 35 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M29.9951 -0.000366211H4.50486C2.154 -0.000366211 0.25 1.90363 0.25 4.25449V29.7448C0.25 32.0956 2.154 33.9996 4.50486 33.9996H29.9951C32.346 33.9996 34.25 32.0956 34.25 29.7448V4.25449C34.25 1.90363 32.346 -0.000366211 29.9951 -0.000366211ZM23.0786 26.5779C20.922 28.0933 18.6877 28.7928 16.0454 28.7928C9.61457 28.7928 4.95171 24.1882 4.95171 17.8545C4.95171 12.2591 9.34257 7.69335 14.7437 7.69335H15.8511L14.3746 6.37221C13.7723 5.82821 13.7334 4.91506 14.258 4.31278C14.802 3.71049 15.7151 3.67163 16.3174 4.19621L20.6306 8.06249C20.9414 8.33449 21.1163 8.74249 21.1163 9.15049C21.1163 9.55849 20.9414 9.96649 20.6306 10.2385L16.3174 14.1048C16.0454 14.3573 15.6957 14.4739 15.346 14.4739C14.938 14.4739 14.5494 14.3185 14.258 13.9882C13.714 13.3859 13.7723 12.4728 14.3746 11.9288L15.8511 10.6076H14.7437C10.9551 10.6076 7.866 13.8522 7.866 17.8545C7.866 22.5756 11.2271 25.8785 16.0454 25.8785C18.0854 25.8785 19.7369 25.3539 21.4077 24.1882C22.0683 23.7219 22.9814 23.8773 23.4283 24.5379C23.8946 25.1985 23.7391 26.1116 23.0786 26.5585V26.5779ZM28.7517 20.5939H17.93C17.1334 20.5939 16.4729 19.9333 16.4729 19.1368C16.4729 18.3402 17.1334 17.6796 17.93 17.6796H28.7517C29.5483 17.6796 30.2089 18.3402 30.2089 19.1368C30.2089 19.9333 29.5483 20.5939 28.7517 20.5939ZM28.7517 14.4739H24.5357C23.7391 14.4739 23.0786 13.8133 23.0786 13.0168C23.0786 12.2202 23.7391 11.5596 24.5357 11.5596H28.7517C29.5483 11.5596 30.2089 12.2202 30.2089 13.0168C30.2089 13.8133 29.5483 14.4739 28.7517 14.4739Z"
      fill="url(#paint0_linear_1462_300)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1462_300"
        x1="17.25"
        y1="-22.7921"
        x2="17.25"
        y2="54.9466"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B3E0FF" />
        <stop offset="1" stopColor="#D7D3FE" />
      </linearGradient>
    </defs>
  </svg>
)

export const AgentsHumanizerIcon = () => (
  <svg width="30" height="35" viewBox="0 0 30 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.6488 14.9064C18.5443 14.9064 21.7023 11.7485 21.7023 7.85294C21.7023 3.9574 18.5443 0.799438 14.6488 0.799438C10.7533 0.799438 7.5953 3.9574 7.5953 7.85294C7.5953 11.7485 10.7533 14.9064 14.6488 14.9064Z"
      fill="url(#paint0_linear_1462_305)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.45404 17.4432C11.8516 17.1827 17.4457 17.1826 19.8432 17.4432C23.6304 17.8428 26.9311 20.7271 27.8172 24.6012H27.7824C28.2167 26.4601 28.6683 29.9004 29.0158 32.8713C29.1546 33.8961 28.3386 34.7994 27.2963 34.7994H1.9661C0.923814 34.7994 0.125151 33.9135 0.2466 32.8713C0.611436 29.9178 1.06307 26.4775 1.48003 24.6012C2.34875 20.7271 5.66675 17.8428 9.45404 17.4432ZM20.1375 22.1861C18.6608 20.7616 15.8118 22.0122 14.6651 24.0795C13.5185 22.0296 10.6868 20.7616 9.19276 22.1861C7.5945 23.7322 8.60197 26.2336 10.6518 28.2141C12.198 29.7082 13.5015 30.6814 14.1791 31.1331C14.4743 31.3414 14.856 31.3414 15.1512 31.1331C15.8288 30.6814 17.1149 29.7082 18.6784 28.2141C20.7283 26.2336 21.7358 23.7322 20.1375 22.1861Z"
      fill="url(#paint1_linear_1462_305)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1462_305"
        x1="14.6328"
        y1="-21.9923"
        x2="14.6328"
        y2="55.7464"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B3E0FF" />
        <stop offset="1" stopColor="#D7D3FE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1462_305"
        x1="14.6328"
        y1="-21.9923"
        x2="14.6328"
        y2="55.7464"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B3E0FF" />
        <stop offset="1" stopColor="#D7D3FE" />
      </linearGradient>
    </defs>
  </svg>
)

export const AgentsExpertReviewIcon = () => (
  <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M29.58 11.7868C28.8056 9.91679 30.43 6.38457 29.0133 4.98679C27.5967 3.57012 24.0833 5.19457 22.2133 4.42012C20.4 3.66457 19.0778 0.00012207 17 0.00012207C14.9222 0.00012207 13.6 3.66457 11.7867 4.42012C9.91667 5.19457 6.38444 3.57012 4.98667 4.98679C3.57 6.40346 5.19444 9.91679 4.42 11.7868C3.66444 13.6001 0 14.9223 0 17.0001C0 19.0779 3.66444 20.4001 4.42 22.2135C5.19444 24.0835 3.57 27.6157 4.98667 29.0135C6.40333 30.4301 9.91667 28.8057 11.7867 29.5801C13.6 30.3357 14.9222 34.0001 17 34.0001C19.0778 34.0001 20.4 30.3357 22.2133 29.5801C24.0833 28.8057 27.6156 30.4301 29.0133 29.0135C30.43 27.5968 28.8056 24.0835 29.58 22.2135C30.3356 20.4001 34 19.0779 34 17.0001C34 14.9223 30.3356 13.6001 29.58 11.7868ZM24.9711 13.7512L16.3389 22.3835C16.0367 22.6857 15.6589 22.8179 15.2622 22.8179C14.8656 22.8179 14.4878 22.6668 14.1856 22.3835L9.33111 17.529C8.74556 16.9435 8.74556 15.9801 9.33111 15.3946C9.91667 14.809 10.88 14.809 11.4656 15.3946L15.2433 19.1723L22.8178 11.5979C23.4033 11.0123 24.3667 11.0123 24.9522 11.5979C25.5378 12.1835 25.5378 13.1468 24.9522 13.7323L24.9711 13.7512Z"
      fill="url(#paint0_linear_1462_1765)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1462_1765"
        x1="17"
        y1="-22.7916"
        x2="17"
        y2="54.9471"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B3E0FF" />
        <stop offset="1" stopColor="#D7D3FE" />
      </linearGradient>
    </defs>
  </svg>
)

export const AgentsReaderReactionsIcon = () => (
  <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M31.6031 13.6033C30.5265 13.6033 29.6457 12.7225 29.6457 11.6459V3.91419H4.4148V11.6459C4.4148 12.7225 3.53397 13.6033 2.4574 13.6033C1.38083 13.6033 0.5 12.7225 0.5 11.6459V3.91419C0.5 1.76105 2.26166 -0.000610352 4.4148 -0.000610352H29.6457C31.7988 -0.000610352 33.5604 1.76105 33.5604 3.91419V11.6459C33.5604 12.7225 32.6796 13.6033 31.6031 13.6033Z"
      fill="url(#paint0_linear_1462_1770)"
    />
    <path
      d="M17.0225 20.9639C19.4116 20.9639 21.3483 19.0272 21.3483 16.6381C21.3483 14.249 19.4116 12.3122 17.0225 12.3122C14.6334 12.3122 12.6966 14.249 12.6966 16.6381C12.6966 19.0272 14.6334 20.9639 17.0225 20.9639Z"
      fill="url(#paint1_linear_1462_1770)"
    />
    <path
      d="M27.5903 23.1369C29.9794 23.1369 31.9161 21.2001 31.9161 18.811C31.9161 16.4219 29.9794 14.4852 27.5903 14.4852C25.2012 14.4852 23.2644 16.4219 23.2644 18.811C23.2644 21.2001 25.2012 23.1369 27.5903 23.1369Z"
      fill="url(#paint2_linear_1462_1770)"
    />
    <path
      d="M6.47125 23.1369C8.86035 23.1369 10.7971 21.2001 10.7971 18.811C10.7971 16.4219 8.86035 14.4852 6.47125 14.4852C4.08215 14.4852 2.1454 16.4219 2.1454 18.811C2.1454 21.2001 4.08215 23.1369 6.47125 23.1369Z"
      fill="url(#paint3_linear_1462_1770)"
    />
    <path
      d="M16.2973 22.9022H17.7458C20.6036 22.9022 22.9329 25.2315 22.9329 28.0893V34.0006H11.1102V28.0893C11.1102 25.2315 13.4395 22.9022 16.2973 22.9022Z"
      fill="url(#paint4_linear_1462_1770)"
    />
    <path
      d="M5.74613 25.0733H7.19461C10.0524 25.0733 12.3817 27.4026 12.3817 30.2604V33.9794H2.51643C1.43986 33.9794 0.559028 33.0986 0.559028 32.022V30.2604C0.559028 27.4026 2.88833 25.0733 5.74613 25.0733Z"
      fill="url(#paint5_linear_1462_1770)"
    />
    <path
      d="M26.867 25.0733H28.3155C31.1733 25.0733 33.5026 27.4026 33.5026 30.2604V32.022C33.5026 33.0986 32.6218 33.9794 31.5452 33.9794H21.6799V30.2604C21.6799 27.4026 24.0092 25.0733 26.867 25.0733Z"
      fill="url(#paint6_linear_1462_1770)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1462_1770"
        x1="17.0302"
        y1="-22.7932"
        x2="17.0302"
        y2="54.9483"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B3E0FF" />
        <stop offset="1" stopColor="#D7D3FE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1462_1770"
        x1="17.0302"
        y1="-22.7932"
        x2="17.0302"
        y2="54.9483"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B3E0FF" />
        <stop offset="1" stopColor="#D7D3FE" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1462_1770"
        x1="17.0302"
        y1="-22.7932"
        x2="17.0302"
        y2="54.9483"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B3E0FF" />
        <stop offset="1" stopColor="#D7D3FE" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1462_1770"
        x1="17.0302"
        y1="-22.7932"
        x2="17.0302"
        y2="54.9483"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B3E0FF" />
        <stop offset="1" stopColor="#D7D3FE" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1462_1770"
        x1="17.0302"
        y1="-22.7932"
        x2="17.0302"
        y2="54.9483"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B3E0FF" />
        <stop offset="1" stopColor="#D7D3FE" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1462_1770"
        x1="17.0302"
        y1="-22.7932"
        x2="17.0302"
        y2="54.9483"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B3E0FF" />
        <stop offset="1" stopColor="#D7D3FE" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1462_1770"
        x1="17.0302"
        y1="-22.7932"
        x2="17.0302"
        y2="54.9483"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B3E0FF" />
        <stop offset="1" stopColor="#D7D3FE" />
      </linearGradient>
    </defs>
  </svg>
)

export const InterfacePlusIcon = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.0003 0.666626C14.9208 0.666626 15.667 1.41282 15.667 2.33329V12.3333H25.667L25.8379 12.3414C26.6781 12.427 27.3337 13.1372 27.3337 14C27.3337 14.8628 26.6781 15.5729 25.8379 15.6585L25.667 15.6666H15.667V25.6666L15.6589 25.8375C15.5733 26.6777 14.8631 27.3333 14.0003 27.3333C13.1375 27.3333 12.4274 26.6777 12.3418 25.8375L12.3337 25.6666V15.6666H2.33366C1.41318 15.6666 0.666992 14.9204 0.666992 14C0.666992 13.0795 1.41318 12.3333 2.33366 12.3333H12.3337V2.33329C12.3337 1.41282 13.0799 0.666626 14.0003 0.666626Z"
      fill="url(#paint0_linear_2681_6401)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2681_6401"
        x1="14.0003"
        y1="-17.2093"
        x2="14.0003"
        y2="43.7623"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B3E0FF" />
        <stop offset="1" stopColor="#D7D3FE" />
      </linearGradient>
    </defs>
  </svg>
)

export const AgentsActive = () => (
  <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M66 34C66 9.46667 60.6667 2 34 2C9.46667 2 2 9.46667 2 34C2 58.5333 9.46667 66 34 66C58.5333 66 66 58.5333 66 34Z"
      stroke="url(#paint0_linear_8_132)"
      strokeWidth="3"
    />
    <defs>
      <linearGradient
        id="paint0_linear_8_132"
        x1="34"
        y1="2"
        x2="34"
        y2="66"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B3E0FF" />
        <stop offset="1" stopColor="#D7D3FE" />
      </linearGradient>
    </defs>
  </svg>
)

export const GmailIcon = () => (
  <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.0919 38.0059V22.7965L8.29895 18.4813L4.00098 16.0867V35.3218C4.00098 36.8069 5.22363 38.0059 6.72832 38.0059H13.0919Z"
      fill="white"
      fillOpacity="0.41"
    />
    <path
      d="M34.9092 38.0057H41.2728C42.782 38.0057 44.0001 36.8023 44.0001 35.3217V16.0867L39.132 18.8295L34.9092 22.7964V38.0057Z"
      fill="#34A853"
    />
    <path
      d="M13.0916 22.7968L12.4395 16.854L13.0916 11.1663L24.0007 19.2182L34.9098 11.1663L35.6395 16.547L34.9098 22.7968L24.0007 30.8487L13.0916 22.7968Z"
      fill="#EA4335"
    />
    <path
      d="M34.9092 11.1654V22.7959L44.0001 16.086V12.5074C44.0001 9.18824 40.1501 7.29611 37.4548 9.28665L34.9092 11.1654Z"
      fill="#FBBC04"
    />
    <path
      d="M4 16.0856L8.1811 19.1718L13.091 22.7955V11.165L10.5453 9.28624C7.84532 7.29554 4 9.18782 4 12.5068V16.0855V16.0856Z"
      fill="#C5221F"
    />
  </svg>
)

export const CalendarIcon = () => (
  <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M34.0001 14.5059H14.0001V34.5058H34.0001V14.5059Z" fill="white" />
    <path
      d="M33.9999 43.5059L43 34.5058L38.4999 33.7381L34.0001 34.5058L33.1786 38.622L33.9999 43.5059Z"
      fill="#EA4335"
    />
    <path
      d="M5 34.5058V40.5058C5 42.1634 6.34248 43.5059 7.99994 43.5059H14.0001L14.9242 39.0058L14.0001 34.5058L9.09675 33.7381L5 34.5058Z"
      fill="#188038"
    />
    <path
      d="M43 14.5059V8.50578C43 6.84833 41.6575 5.50586 40.0001 5.50586H33.9999C33.4524 7.73777 33.1786 9.38023 33.1786 10.4334C33.1786 11.4864 33.4527 12.844 34.0001 14.5059C35.9907 15.0759 37.4904 15.3609 38.4999 15.3609C39.5095 15.3609 41.0094 15.0759 43 14.5059Z"
      fill="#1967D2"
    />
    <path d="M43 14.5059H34.0001V34.5058L43 34.5058V14.5059Z" fill="#FBBC04" />
    <path d="M34.0001 34.5058H14.0001L14.0001 43.5059H33.9999L34.0001 34.5058Z" fill="#34A853" />
    <path
      d="M33.9999 5.50586H8.00009C6.34248 5.50586 5 6.84833 5 8.50578V34.5058L14.0001 34.5058V14.5059H34.0001L33.9999 5.50586Z"
      fill="#4285F4"
    />
    <path
      d="M18.1026 30.0209C17.3551 29.5159 16.8375 28.7785 16.555 27.8032L18.2901 27.0884C18.4474 27.6884 18.7225 28.1534 19.1151 28.4834C19.5051 28.8134 19.9801 28.9759 20.5351 28.9759C21.1026 28.9759 21.59 28.8034 21.9975 28.4583C22.4051 28.1133 22.6101 27.6734 22.6101 27.1409C22.6101 26.5959 22.395 26.1508 21.9651 25.8059C21.5351 25.4609 20.9951 25.2884 20.3501 25.2884H19.3476V23.571H20.2476C20.8026 23.571 21.27 23.4209 21.65 23.1208C22.03 22.8209 22.22 22.4108 22.22 21.8883C22.22 21.4234 22.0501 21.0533 21.7101 20.7759C21.3702 20.4983 20.94 20.3584 20.4175 20.3584C19.9075 20.3584 19.5025 20.4934 19.2026 20.7658C18.9027 21.0391 18.6773 21.3841 18.5475 21.7684L16.8301 21.0533C17.0575 20.4084 17.475 19.8384 18.0875 19.3459C18.7001 18.8534 19.4825 18.6059 20.4325 18.6059C21.1351 18.6059 21.7676 18.741 22.3276 19.0134C22.8875 19.2859 23.3275 19.6634 23.645 20.1434C23.9627 20.6258 24.12 21.1659 24.12 21.7658C24.12 22.3783 23.9726 22.8959 23.6777 23.3209C23.3826 23.7459 23.0201 24.0708 22.5901 24.2983V24.4008C23.1453 24.6297 23.6276 25.0057 23.9851 25.4884C24.3476 25.9758 24.5302 26.5583 24.5302 27.2384C24.5302 27.9183 24.3575 28.5258 24.0126 29.0583C23.6676 29.5909 23.1902 30.0108 22.585 30.3158C21.9776 30.6209 21.2951 30.776 20.5376 30.776C19.66 30.7784 18.8502 30.5259 18.1026 30.0209ZM28.7601 21.4108L26.8552 22.7883L25.9026 21.3434L29.3201 18.8783H30.6301V30.5058H28.7601V21.4108Z"
      fill="#4285F4"
    />
  </svg>
)

export const JiraIcon = () => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.0713 1.62231H11.8008C11.8008 4.18231 13.8731 6.25469 16.4331 6.25469H18.3226V8.08329C18.3226 10.6433 20.395 12.7156 22.955 12.7156V2.50613C22.955 2.0185 22.5588 1.62231 22.0713 1.62231Z"
      fill="#2684FF"
    />
    <path
      d="M16.9824 6.74219H6.71191C6.71191 9.30218 8.78428 11.3745 11.3443 11.3745H13.2338V13.2032C13.2338 15.7632 15.3062 17.8355 17.8662 17.8355V7.626C17.8662 7.13836 17.47 6.74219 16.9824 6.74219Z"
      fill="url(#paint0_linear_1788_5437)"
    />
    <path
      d="M11.8926 11.8623H1.62207C1.62207 14.4223 3.69445 16.4947 6.25445 16.4947H8.14394V18.3233C8.14394 20.8833 10.2164 22.9556 12.7764 22.9556V12.7461C12.7764 12.2585 12.3802 11.8623 11.8926 11.8623Z"
      fill="url(#paint1_linear_1788_5437)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1788_5437"
        x1="17.653"
        y1="6.75334"
        x2="13.283"
        y2="11.2599"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.176" stopColor="#0052CC" />
        <stop offset="1" stopColor="#2684FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1788_5437"
        x1="12.8586"
        y1="11.9011"
        x2="7.80589"
        y2="16.8172"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.176" stopColor="#0052CC" />
        <stop offset="1" stopColor="#2684FF" />
      </linearGradient>
    </defs>
  </svg>
)

export const OutlookIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M27.3341 16.5365C27.3354 16.3592 27.2438 16.1943 27.0927 16.1016H27.0901L27.0806 16.0963L19.2263 11.447C19.1924 11.4241 19.1572 11.4032 19.1209 11.3843C18.8176 11.2279 18.4574 11.2279 18.1541 11.3843C18.1178 11.4032 18.0826 11.4241 18.0487 11.447L10.1945 16.0963L10.185 16.1016C9.94493 16.2509 9.87134 16.5665 10.0206 16.8066C10.0646 16.8773 10.1252 16.9362 10.1971 16.9782L18.0514 21.6275C18.0854 21.6502 18.1206 21.6712 18.1568 21.6903C18.46 21.8467 18.8203 21.8467 19.1236 21.6903C19.1598 21.6712 19.1949 21.6503 19.229 21.6275L27.0832 16.9782C27.2401 16.8867 27.3359 16.7181 27.3341 16.5365Z"
      fill="#0A2767"
    />
    <path
      d="M11.1095 13.432H16.2638V18.1567H11.1095V13.432ZM26.2793 8.62934V6.4681C26.2916 5.92774 25.8639 5.4795 25.3236 5.46655H11.9481C11.4078 5.4795 10.9801 5.92774 10.9924 6.4681V8.62934L18.8994 10.7379L26.2793 8.62934Z"
      fill="#0364B8"
    />
    <path d="M10.9922 8.62939H16.2635V13.3736H10.9922V8.62939Z" fill="#0078D4" />
    <path
      d="M21.535 8.62939H16.2637V13.3736L21.535 18.1178H26.2792V13.3736L21.535 8.62939Z"
      fill="#28A8EA"
    />
    <path d="M16.2637 13.3735H21.535V18.1177H16.2637V13.3735Z" fill="#0078D4" />
    <path d="M16.2637 18.1177H21.535V22.8619H16.2637V18.1177Z" fill="#0364B8" />
    <path d="M11.1094 18.1567H16.2637V22.4518H11.1094V18.1567Z" fill="#14447D" />
    <path d="M21.5352 18.1177H26.2793V22.8619H21.5352V18.1177Z" fill="#0078D4" />
    <path
      d="M27.0924 16.9492L27.0824 16.9545L19.2281 21.3719C19.1938 21.393 19.1591 21.413 19.1227 21.4309C18.9893 21.4944 18.8444 21.5303 18.6968 21.5363L18.2677 21.2854C18.2314 21.2672 18.1962 21.247 18.1622 21.2248L10.2026 16.682H10.1989L9.93848 16.5365V25.4788C9.94254 26.0754 10.4293 26.5558 11.0259 26.552H26.2632C26.2722 26.552 26.2801 26.5478 26.2896 26.5478C26.4156 26.5397 26.5398 26.5138 26.6585 26.4708C26.7099 26.4491 26.7594 26.4234 26.8067 26.3939C26.842 26.3738 26.9026 26.3301 26.9026 26.3301C27.1726 26.1303 27.3325 25.8147 27.3338 25.4788V16.5365C27.3336 16.7075 27.2414 16.8652 27.0924 16.9492Z"
      fill="url(#paint0_linear_2822_9282)"
    />
    <path
      opacity="0.5"
      d="M26.9119 16.5011V17.0493L18.6992 22.7039L10.1966 16.6856C10.1966 16.6827 10.1942 16.6803 10.1913 16.6803L9.41113 16.2112V15.8158L9.73269 15.8105L10.4127 16.2006L10.4285 16.2059L10.4865 16.2428C10.4865 16.2428 18.4778 20.8025 18.4989 20.813L18.8046 20.9922C18.831 20.9817 18.8573 20.9712 18.8889 20.9606C18.9048 20.9501 26.8223 16.4958 26.8223 16.4958L26.9119 16.5011Z"
      fill="#0A2767"
    />
    <path
      d="M27.0924 16.9492L27.0824 16.955L19.2281 21.3724C19.1938 21.3935 19.159 21.4135 19.1227 21.4314C18.8176 21.5804 18.4609 21.5804 18.1559 21.4314C18.1198 21.4135 18.0846 21.3938 18.0505 21.3724L10.1962 16.955L10.1868 16.9492C10.0351 16.867 9.94005 16.709 9.93848 16.5365V25.4788C9.94225 26.0753 10.4289 26.5558 11.0254 26.552C11.0254 26.552 11.0254 26.552 11.0254 26.552H26.2469C26.8434 26.5558 27.33 26.0753 27.3338 25.4788C27.3338 25.4788 27.3338 25.4788 27.3338 25.4788V16.5365C27.3336 16.7075 27.2414 16.8652 27.0924 16.9492Z"
      fill="#1490DF"
    />
    <path
      opacity="0.1"
      d="M19.3424 21.307L19.2248 21.3729C19.1908 21.3946 19.1556 21.4145 19.1194 21.4325C18.9899 21.496 18.8491 21.5333 18.7051 21.5421L21.6934 25.076L26.9062 26.3322C27.049 26.2243 27.1626 26.0824 27.2367 25.9194L19.3424 21.307Z"
      fill="black"
    />
    <path
      opacity="0.05"
      d="M19.8748 21.0076L19.2248 21.3729C19.1908 21.3946 19.1556 21.4144 19.1194 21.4324C18.9899 21.496 18.8491 21.5333 18.7051 21.5421L20.1051 25.4023L26.9078 26.3305C27.1758 26.1293 27.3335 25.8138 27.3337 25.4787V25.3632L19.8748 21.0076Z"
      fill="black"
    />
    <path
      d="M11.0402 26.552H26.2453C26.4793 26.5532 26.7074 26.4793 26.8963 26.3411L18.2671 21.2865C18.2309 21.2683 18.1957 21.2481 18.1617 21.2259L10.202 16.683H10.1983L9.93848 16.5365V25.4482C9.93788 26.0572 10.4311 26.5514 11.0402 26.552Z"
      fill="#28A8EA"
    />
    <path
      opacity="0.1"
      d="M17.3183 10.6499V21.8937C17.3174 22.2879 17.0777 22.6422 16.7121 22.7898C16.5989 22.8384 16.4769 22.8636 16.3537 22.8636H9.93848V10.2108H10.9927V9.68372H16.3537C16.8862 9.68573 17.3172 10.1174 17.3183 10.6499Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M16.7912 11.177V22.4207C16.7925 22.548 16.7655 22.6741 16.7121 22.7897C16.5657 23.1505 16.2159 23.3872 15.8265 23.389H9.93848V10.2107H15.8265C15.9795 10.2092 16.1302 10.2474 16.2641 10.3214C16.5872 10.4842 16.7911 10.8151 16.7912 11.177Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M16.7912 11.177V21.3664C16.7886 21.8987 16.3588 22.3301 15.8265 22.3348H9.93848V10.2107H15.8265C15.9795 10.2092 16.1302 10.2474 16.2641 10.3214C16.5872 10.4842 16.7911 10.8151 16.7912 11.177Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M16.2641 11.1772V21.3666C16.2635 21.8997 15.8325 22.3324 15.2994 22.335H9.93848V10.2109H15.2994C15.8325 10.2112 16.2643 10.6436 16.264 11.1766C16.2641 11.1768 16.2641 11.177 16.2641 11.1772Z"
      fill="black"
    />
    <path
      d="M5.63322 10.2109H15.2976C15.8313 10.2109 16.2639 10.6435 16.2639 11.1772V20.8416C16.2639 21.3752 15.8313 21.8078 15.2976 21.8078H5.63322C5.09958 21.8078 4.66699 21.3752 4.66699 20.8416V11.1772C4.66699 10.6435 5.09959 10.2109 5.63322 10.2109Z"
      fill="url(#paint1_linear_2822_9282)"
    />
    <path
      d="M7.68694 14.2633C7.92508 13.7559 8.30947 13.3313 8.79076 13.044C9.32375 12.7389 9.93061 12.5868 10.5445 12.6044C11.1135 12.5921 11.675 12.7363 12.1676 13.0214C12.6307 13.2976 13.0037 13.7022 13.2413 14.1863C13.5001 14.7197 13.6291 15.3068 13.6177 15.8995C13.6302 16.519 13.4976 17.1328 13.2303 17.6917C12.987 18.1931 12.6021 18.6122 12.1233 18.8973C11.6117 19.1911 11.0294 19.3391 10.4396 19.3253C9.85848 19.3393 9.28465 19.1935 8.78074 18.9036C8.31359 18.6271 7.9359 18.2219 7.69275 17.7365C7.43244 17.2108 7.30195 16.6304 7.31216 16.0439C7.30131 15.4297 7.42944 14.821 7.68694 14.2633ZM8.8635 17.1256C8.99047 17.4464 9.20578 17.7246 9.48446 17.9279C9.7683 18.1263 10.1082 18.2286 10.4544 18.2199C10.8231 18.2345 11.1865 18.1287 11.4897 17.9184C11.7648 17.7157 11.9745 17.4368 12.0927 17.1161C12.2249 16.758 12.2901 16.3787 12.2851 15.997C12.2892 15.6117 12.2279 15.2285 12.1038 14.8637C11.9941 14.5343 11.7912 14.2439 11.5197 14.0277C11.2241 13.8074 10.8617 13.6957 10.4934 13.7114C10.1397 13.7022 9.79219 13.8054 9.5008 14.006C9.21741 14.2102 8.99801 14.4909 8.86824 14.8152C8.58037 15.5585 8.57887 16.3823 8.86402 17.1267L8.8635 17.1256Z"
      fill="white"
    />
    <path d="M21.5352 8.62939H26.2793V13.3736H21.5352V8.62939Z" fill="#50D9FF" />
    <defs>
      <linearGradient
        id="paint0_linear_2822_9282"
        x1="18.6361"
        y1="16.5365"
        x2="18.6361"
        y2="26.552"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#35B8F1" />
        <stop offset="1" stopColor="#28A8EA" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2822_9282"
        x1="6.68161"
        y1="9.45594"
        x2="14.2493"
        y2="22.5628"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1784D9" />
        <stop offset="0.5" stopColor="#107AD5" />
        <stop offset="1" stopColor="#0A63C9" />
      </linearGradient>
    </defs>
  </svg>
)
